import Axios from 'axios'
import config from './config'

Axios.defaults.withCredentials = true

const apiUrls = {
  remote: config.authRemoteApiUrl,
  local: config.authLocalApiUrl
}


const validateBetaKey = async({apiSource,betaKey}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/validateBetaAccessKey/${betaKey}`
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error validating beta key"}
  }
}

const checkLoggedIn = async ({ apiSource }) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/checkLoginToken`
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error verifying login"}
  }
}

const login = async ({ apiSource, email, password }) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/login`,
      data: {
        email,
        password,
      }
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error during login"}
  }
}

const logout = async ({ apiSource }) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/logout`
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error during logout"}
  }
}

const signup = async ({ apiSource, email, password, name }) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/signup`,
      data: {
        email,
        password,
        name,
      }
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error signign up"}
  }
}

const oauthLogin = async ({ apiSource, token }) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/oauth/login`,
      data: { token }
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error oAuth login"}
  }
}

const googleSigninStart = async ({ apiSource }) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/oauth/googleSigninStart`
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error starting google signin"}
  }
}

const appleSigninStart = async ({ apiSource }) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/oauth/appleSigninStart`,
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error starting apple signin"}
  }
}

const linkedinSigninStart = async ({ apiSource }) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/oauth/linkedinSigninStart`
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error starting linkedin signin"}
  }
}


const checkEmailAvailability = async ({ apiSource, apiKeys, email }) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/oauth/checkEmailAvailability`,
      data: { email }
    }

    let data = await callApi({ apiSource, apiKeys, options })

    return data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error checkign email availability"}
  }
}

const requestEmailVerificationCode = async ({ apiSource, apiKeys, email, user_id, username }) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/oauth/requestEmailVerification`,
      data: { email, user_id, username }
    }

    let data = await callApi({ apiSource, apiKeys, options })

    return data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error starting email verification"}
  }
}

const verifyEmailCode = async ({ apiSource, apiKeys, user_id, code }) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/oauth/verifyEmailCode`,
      data: { code, user_id }
    }

    let data = await callApi({ apiSource, apiKeys, options })

    return data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error verifying email code"}
  }
}


const resetUserPasswordRequest = async ({ apiSource,email }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/password/resetUserPasswordRequest`,
      method: "put",
      data: { email }
    }

    let result = await Axios(options)

    return result.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error resetting password"}
  }
}

const verifyChangePasswordRequest = async ({ apiSource,token }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/password/verifyChangePasswordRequest/` + token,
      method: "get"
    }

    let result = await Axios(options)

    return result.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error verifying password change request"}
  }
}


const updateUserPassword = async ({ apiSource, apiKeys, password }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/password/updateUserPassword`,
      method: "patch",
      data: {
        password
      }
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error updating password"}
  }
}


const acceptInviteAndLogin = async ({ apiSource, password, token, providerToken }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/signup/acceptInviteAndLogin`,
      method: "put",
      data: {
        password,
        token,
        providerToken
      }
    }

    let result = await Axios(options)

    return result.data
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error accepting invite"}
  }
}

const callApi = async ({ apiSource, apiKeys, options }) => {
  try {
    const mode = Object.keys(apiKeys)[0]

    if (apiSource === "local") {
      options.headers = {
        'x-api-key': config.localApiKey,
        'Authorization': apiKeys[mode],
        'Content-type': 'application/json',
      }
    } else {
      options.headers = {
        'x-api-key': apiKeys[mode],
        'Content-type': 'application/json',
      }
    }
    
    options.withCredentials = true

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    throw err
  }
}

export {
  acceptInviteAndLogin,
  checkLoggedIn,
  googleSigninStart,
  appleSigninStart,
  linkedinSigninStart,
  login,
  logout,
  oauthLogin,
  checkEmailAvailability,
  requestEmailVerificationCode,
  resetUserPasswordRequest,
  signup,
  updateUserPassword,
  validateBetaKey,
  verifyEmailCode,
  verifyChangePasswordRequest,
}
